export const isTeamsApp = process.env.PLATFORM_ENV !== 'web'
export const MOBILE_BREAKPOINT = 768
